import React from 'react';
import PropTypes from 'prop-types';
import thirdBridgeLogo from '@assets/ThirdBridgeHeaderLogo.svg';
import { AttendeeHeaderContainer, ButtonContainer } from '@layout/Header';
import { FlexContainer } from '@layout';
import { Button, Icon } from '@atoms';

export const AttendeeHeader = ({ logoutOnClick, email }) => (
  <AttendeeHeaderContainer>
    <img src={thirdBridgeLogo} alt="Third Bridge logo" />
    <ButtonContainer />
    <FlexContainer inline gap="10px">
      <span>{email}</span>
      <Button primary invisible onClick={logoutOnClick}>
        <Icon name="logout" style={{ transform: 'rotate(180deg)' }} />
      </Button>
    </FlexContainer>
  </AttendeeHeaderContainer>
);

AttendeeHeader.propTypes = {
  logoutOnClick: PropTypes.func.isRequired,
  email: PropTypes.string,
};

AttendeeHeader.defaultProps = {
  email: '',
};



// WEBPACK FOOTER //
// ./components/templates/AttendeeHeader/AttendeeHeader.js